/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormEuropeanUnionData() {
  return {
    type: RESET_EUROPEAN_UNION_STATE,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}
export function resetFormTravelDelay() {
  return {
    type: RESET_TRAVEL_DELAY_STATE,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.IPMI.MedicalExpense/actions.js